module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/pl-card-drag.0ee6c5a6a886d4627f58.gif";